import type { Article } from '@/types/content';

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '《姐姐的朋友》：为什么克制，反而更让人心动',
    summary: '没有激烈的冲突，也没有狗血的告白，这部电影用大量留白讲述了一段「点到为止」的暗恋。我们聊聊它为什么能在众多爱情片中脱颖而出。',
    date: '2026-09-28',
    topicId: 'topic-1',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20film%20review%20illustration%20of%20two%20coffee%20cups%20on%20a%20wooden%20table%20by%20a%20rainy%20window%2C%20moody%20navy%20and%20warm%20amber%20tones%2C%20soft%20light%2C%20minimalist%20composition%2C%20high%20detail&width=800&height=500&seq=art-jjdp-1&orientation=landscape',
  },
  {
    id: 'article-2',
    title: '江辰这个角色，到底迷人在哪里',
    summary: '他不是传统意义上的完美男主，甚至有些「不主动」。但正是这份克制与分寸感，让这个角色成为许多观众心中的白月光。',
    date: '2026-09-25',
    topicId: 'topic-1',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20article%20image%20of%20a%20lone%20silhouette%20standing%20on%20a%20city%20overpass%20at%20dusk%2C%20deep%20navy%20sky%20with%20warm%20street%20lights%2C%20cinematic%20mood%2C%20minimalist%20composition%2C%20high%20detail&width=800&height=500&seq=art-jjdp-2&orientation=landscape',
  },
  {
    id: 'article-3',
    title: '从电影到剧集：《姐姐的朋友》的五年之约',
    summary: '剧集版《重逢》延续了电影的世界观，却把视角拉得更宽。主创团队分享了这次「续写」背后的想法与取舍。',
    date: '2026-09-20',
    topicId: 'topic-1',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20image%20of%20empty%20director%20chairs%20on%20a%20film%20set%20at%20golden%20hour%2C%20warm%20amber%20light%20with%20navy%20shadows%2C%20cinematic%20minimalist%20composition%2C%20high%20detail&width=800&height=500&seq=art-jjdp-3&orientation=landscape',
  },
  {
    id: 'article-4',
    title: '2025 暑期档观察：类型片正在找到新解法',
    summary: '从科幻到动作，从文艺到青春，这一年的暑期档出现了不少让人眼前一亮的作品。我们盘点了其中的创作趋势。',
    date: '2026-09-12',
    topicId: 'topic-2',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20glowing%20cinema%20marquee%20at%20night%2C%20deep%20navy%20sky%20with%20warm%20amber%20bulbs%2C%20nostalgic%20cinematic%20mood%2C%20minimalist%20composition%2C%20high%20detail&width=800&height=500&seq=art-summer-1&orientation=landscape',
  },
  {
    id: 'article-5',
    title: '科幻爱情片为什么越来越好看',
    summary: '《星尘之约》的成功，让人们重新注意到科幻与情感题材结合的潜力。这类作品的关键，从来都不只是特效。',
    date: '2026-09-08',
    topicId: 'topic-2',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20vast%20starfield%20with%20a%20warm%20glowing%20nebula%2C%20deep%20navy%20cosmos%2C%20soft%20light%2C%20minimalist%20cinematic%20composition%2C%20high%20detail&width=800&height=500&seq=art-summer-2&orientation=landscape',
  },
  {
    id: 'article-6',
    title: '年度高分剧集盘点：这十部值得二刷',
    summary: '悬疑、年代、都市、青春……我们按题材整理了今年评分与口碑俱佳的十部剧集，附上观影顺序建议。',
    date: '2026-09-30',
    topicId: 'topic-3',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20cozy%20living%20room%20with%20a%20glowing%20television%20and%20warm%20lamp%20light%20at%20night%2C%20navy%20and%20amber%20tones%2C%20minimalist%20composition%2C%20high%20detail&width=800&height=500&seq=art-series-1&orientation=landscape',
  },
  {
    id: 'article-7',
    title: '《长夜将明》的剧本，赢在哪里',
    summary: '作为今年最高分的悬疑剧之一，《长夜将明》几乎不靠巧合推动剧情。我们拆解了它严密的线索设计与节奏控制。',
    date: '2026-09-22',
    topicId: 'topic-3',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20noir%20desk%20with%20a%20magnifying%20glass%20and%20case%20files%20under%20a%20single%20warm%20lamp%2C%20deep%20navy%20shadows%2C%20cinematic%20mood%2C%20high%20detail&width=800&height=500&seq=art-series-2&orientation=landscape',
  },
  {
    id: 'article-8',
    title: '实力派演员幕后：一个角色是怎样诞生的',
    summary: '走进片场，记录演员们为角色做的准备——从方言训练到体态调整，那些观众在屏幕上未必看得见的功课。',
    date: '2026-09-18',
    topicId: 'topic-4',
    cover: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20editorial%20image%20of%20a%20film%20script%20and%20headphones%20on%20a%20director%20table%2C%20warm%20amber%20lighting%20with%20navy%20shadows%2C%20cinematic%20minimalist%20composition%2C%20high%20detail&width=800&height=500&seq=art-actor-1&orientation=landscape',
  },
  {
    id: 'article-9',
    title: '林知夏：把情绪藏在眼神里',
    summary: '从《姐姐的朋友》到《追光者》，她一次次用细微的表情变化打动观众。这是一次关于表演方法的深度对话。',
    date: '2026-09-14',
    topicId: 'topic-4',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20rehearsal%20room%20mirror%20with%20warm%20light%2C%20empty%20stage%20chairs%2C%20navy%20and%20amber%20tones%2C%20cinematic%20minimalist%20composition%2C%20high%20detail&width=800&height=500&seq=art-actor-2&orientation=landscape',
  },
];